import React, { useState, useEffect, useRef } from "react";
import { Routes, Route } from "react-router-dom";
// Landing Page Imports
import Home from "./components/Pages/Home";
import AboutUs from "./components/Pages/AboutUs";
import Services from "./components/Pages/Services";
import PrivacyPolicy from "./components/Pages/PrivacyPolicy";
import CustomerSupport from "./components/Pages/CustomerSupport";
// PagesNotFind Routes Here //////////////////////////////////////////////////////////////////.....................
import SoonPage from "./components/PageNotFound/SoonPage";
// NavFoot Imports
import Navbar from "./components/NavFoot/Navbar";
import Footer from "./components/NavFoot/Footer";
// Only Problem Solving Category Blogs Here
import BlogNpmErrors from "./components/Blogs/ProblemSolving/NpmErrors";
import SlowLaptop from "./components/Blogs/ProblemSolving/SlowLaptop";
import HostingDomainSolution from "./components/Blogs/ProblemSolving/HostingDomainSolution";
import MobileResponsiveness from "./components/Blogs/ProblemSolving/MobileResponsiveness";
import ECommerceSolutions from "./components/Blogs/ProblemSolving/ECommerceSolutions";
import SecuritySolutions from "./components/Blogs/ProblemSolving/SecuritySolutions";
// Only RealLife Gadgets Category Blogs Here ///////////////////////////////////////////////////////////////////////..................
import NightSleepMask from "./components/Blogs/RealLifeGadgets/NightSleepMask";
import SmartClock from "./components/Blogs/RealLifeGadgets/SmartClock";
import PushUpBoard from "./components/Blogs/RealLifeGadgets/PushUpBoard";
import ElectricSpinScrubber from "./components/Blogs/RealLifeGadgets/ElectricSpinScrubber";
import RechargeableSpotlight from "./components/Blogs/RealLifeGadgets/RechargeableSpotlight";
import ChargeablePoleSawChainSaw from "./components/Blogs/RealLifeGadgets/ChargeablePoleSawChainSaw";
// Only Perfect Gifts Guide Category Blogs Here ///////////////////////////////////////////////////////////////////////..................
import GoldPlatedFlower from "./components/Blogs/PerfectGiftsGuide/GoldPlatedFlower";
import MuscleMassager from "./components/Blogs/PerfectGiftsGuide/MuscleMassager";
import AdvancedDrone from "./components/Blogs/PerfectGiftsGuide/AdvancedDrone";
import OLED from "./components/Blogs/PerfectGiftsGuide/OLED";
import SummerDress from "./components/Blogs/PerfectGiftsGuide/SummerDress";
import FleeceBalaclava from "./components/Blogs/PerfectGiftsGuide/FleeceBalaclava";
// Functions Imports
import ScrollToTop from "./Functions/ScrollToTop";
// import CanonicalLinkUpdater from './Functions/CanonicalLinkUpdater'; // Import the CanonicalLinkUpdater
// Style Sheets
import "./App.css";

// Debounce
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
// Global Imports
import { useGlobalState } from "./Functions/GlobalStates";

const App = () => {
  // Global States Here //////////////////////////////////////////////////////...............................
  const { setAllPagesWidthHeight } = useGlobalState();

  // States Here
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  // React Elements References Here //////////////////////////////////// ...............
  const AppRef = useRef(false); // Ref for the absolute box

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = debounce(() => {
      if (AppRef.current) {
        const { width, height } = AppRef.current.getBoundingClientRect();

        // Prevent unnecessary updates
        if (dimensions.width !== width || dimensions.height !== height) {
          setDimensions({ width, height });

          setAllPagesWidthHeight((prev) => {
            // Only update if the height is actually changing
            if (prev.height !== parseFloat(height.toFixed(1))) {
              return { ...prev, height: parseFloat(height.toFixed(1)) };
            }
            return prev; // Prevents unnecessary state updates
          });
        }
      }
    }, 100);

    updateSize(); // Run once on mount

    const scrolleventwait = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", scrolleventwait);

    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", scrolleventwait);
    };
  }, [dimensions]); // Depend on dimensions to avoid infinite loops
  return (
    <div ref={AppRef}>

      {/* Canonical Link Updater Will update The Links For Each Pages ok */}
      {/* <CanonicalLinkUpdater /> */}

      <Navbar />
      <ScrollToTop />


      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/customer-support" element={<CustomerSupport />} />
        {/* PagesNotFind Routes Here //////////////////////////////////////////////////////////////////.....................  */}
        <Route path="/comingsoon" element={<SoonPage />} />

        {/* // Only Problem Solving Category Blogs Here ///////////////////////////////////////////////////////////////////////.................. */}
        <Route path="/problemsolving/npmerrors" element={<BlogNpmErrors />} />
        <Route path="/problemsolving/slowlaptop" element={<SlowLaptop />} />
        <Route
          path="/problemsolving/hostingdomainsolution"
          element={<HostingDomainSolution />}
        />
        <Route
          path="/problemsolving/mobileresponsiveness"
          element={<MobileResponsiveness />}
        />
        <Route
          path="/problemsolving/ecommercesolutions"
          element={<ECommerceSolutions />}
        />
        <Route
          path="/problemsolving/securitysolutions"
          element={<SecuritySolutions />}
        />

        {/* // Only RealLife Gadgets Category Blogs Here ///////////////////////////////////////////////////////////////////////.................. */}
        <Route
          path="/reallifegadgets/nightsleepmask"
          element={<NightSleepMask />}
        />
        <Route path="/reallifegadgets/smartclock" element={<SmartClock />} />
        <Route path="/reallifegadgets/pushupboard" element={<PushUpBoard />} />
        <Route
          path="/reallifegadgets/electricspinscrubber"
          element={<ElectricSpinScrubber />}
        />
        <Route
          path="/reallifegadgets/rechargeablespotlight"
          element={<RechargeableSpotlight />}
        />
        <Route
          path="/reallifegadgets/chargeablepolesawchainsaw"
          element={<ChargeablePoleSawChainSaw />}
        />
        {/* // Only Perfect Gifts Guide Category Blogs Here ///////////////////////////////////////////////////////////////////////.................. */}
        <Route
          path="/PerfectGiftsGuide/goldplatedflower"
          element={<GoldPlatedFlower />}
        />
        <Route
          path="/PerfectGiftsGuide/musclemassager"
          element={<MuscleMassager />}
        />
        <Route
          path="/PerfectGiftsGuide/advanceddrone"
          element={<AdvancedDrone />}
        />
        <Route path="/PerfectGiftsGuide/oled" element={<OLED />} />
        <Route
          path="/PerfectGiftsGuide/summerdress"
          element={<SummerDress />}
        />
        <Route
          path="/PerfectGiftsGuide/fleecebalaclava"
          element={<FleeceBalaclava />}
        />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
